import React from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography} from '@mui/material';
import {useLocation, useNavigate} from "react-router-dom";
import Strings from "../assets/strings"
import {ReportGmailerrorred} from "@mui/icons-material";

export default function ConfirmDialog({onConfirm,replace, children, title=Strings.confirmar, open, mode="error"}:{onConfirm:Function,replace?:string,children?:any,title?:string, open?:boolean, mode?:"error" | "info" | "success" | "warning"}) {
    let navigate = useNavigate();
    const { state }:{state:any} = useLocation()

    const confirm = () => {
        if(onConfirm) onConfirm();
        if(replace){
            navigate(replace,{replace:true})
        }else {
            navigate(-1)
        }
    };

    return (
        <div>
            <Dialog
                open={open ?? Boolean(state?.confirmDialog)}
                onClose={()=>navigate(-1)}
                fullWidth
                maxWidth={"xs"}
                sx={(theme)=>({"& .MuiDialog-paper": {borderTop: "7px solid "+theme.palette[mode].light}})}
            >
                <DialogContent>
                    <Box display={"flex"} alignItems={"center"}>
                            <ReportGmailerrorred sx={(theme)=>({fontSize:"63px", mr:2, color:theme.palette[mode].light})}/>
                        <Box>
                            <Typography variant={"h6"} color={"grey.700"}>{title}</Typography>
                            {children?(
                                <>{children}</>
                            ):(
                                <DialogContentText>
                                    {Strings.confirmEliminar}
                                </DialogContentText>
                            )}
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ borderTop: "1px solid #d2d2d2"}}>
                    <Button onClick={()=>navigate(-1)} >
                        {Strings.cancelar}
                    </Button>
                    <Button onClick={confirm} color={mode} variant={"contained"}  disableElevation>
                        {Strings.confirmar}
                    </Button>

                </DialogActions>
            </Dialog>
        </div>
    );
}
